import { render, staticRenderFns } from "./index.vue?vue&type=template&id=650b533e&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=650b533e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b533e",
  null
  
)

export default component.exports